import { render } from "./TrainerData.vue?vue&type=template&id=67ddbd68&scoped=true"
import script from "./TrainerData.vue?vue&type=script&lang=js"
export * from "./TrainerData.vue?vue&type=script&lang=js"

import "./TrainerData.vue?vue&type=style&index=0&id=67ddbd68&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ddbd68"]])

export default __exports__